import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { AiFillEye, AiFillEyeInvisible } from 'react-icons/ai'; // Import des icônes pour l'œil
import AdminNavbar from '../../components/Admin/AdminNavbar';
import AdminSidebar from '../../components/Admin/AdminSidebar';
import '../../style/Admin/AdminNavbar.css';
import '../../style/Admin/AdminSideBar.css';
import '../../style/Admin/ModifierProfile.css';

function ModifierProfile() {
  const [nom, setNom] = useState('');
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [showPassword, setShowPassword] = useState(false); // État pour la visibilité du mot de passe
  const [poste, setPoste] = useState(''); 
  const [image, setImage] = useState(null); 
  const [message, setMessage] = useState('');
  const [token] = useState(localStorage.getItem('token') || '');

  useEffect(() => {
    const fetchAdminData = async () => {
      try {
        const response = await axios.get('https://jetagroupe.com/api/admin/profile', {
          headers: { 'Authorization': token }
        });
        const { nom, email, poste, image } = response.data;
        setNom(nom);
        setEmail(email);
        setPoste(poste);
        setImage(image);
      } catch (error) {
        setMessage('Erreur lors du chargement des données de l\'admin');
      }
    };

    if (token) {
      fetchAdminData();
    }
  }, [token]);

  const validateNom = (nom) => /^[A-Za-zÀ-ÖØ-öø-ÿ\s'-]+$/.test(nom);
  const validateEmail = (email) => /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);
  const validatePassword = (password) => password === '' || /^(?=.*[A-Za-z])(?=.*\d)[A-Za-z\d]{8,}$/.test(password);
  const validatePoste = (poste) => /^[A-Za-zÀ-ÖØ-öø-ÿ\s'-]+$/.test(poste);
  const validateImage = (image) => !image || (image.size <= 5 * 1024 * 1024 && ['image/jpeg', 'image/png', 'image/gif'].includes(image.type));

  const handleImageChange = (e) => {
    const selectedImage = e.target.files[0];
    if (validateImage(selectedImage)) {
      setImage(selectedImage);
    } else {
      setMessage('Veuillez sélectionner une image valide (JPEG, PNG, GIF) et de taille inférieure à 5MB.');
      setImage(null);
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!validateNom(nom)) {
      setMessage('Le nom ne doit contenir que des lettres et des espaces.');
      return;
    }

    if (!validateEmail(email)) {
      setMessage('Veuillez entrer un email valide.');
      return;
    }

    if (!validatePassword(password)) {
      setMessage('Le mot de passe doit contenir au moins 8 caractères, dont une lettre et un chiffre.');
      return;
    }

    if (!validatePoste(poste)) {
      setMessage('Le poste ne doit contenir que des lettres et des espaces.');
      return;
    }

    if (!validateImage(image)) {
      setMessage('Veuillez sélectionner une image valide.');
      return;
    }

    try {
      const formData = new FormData();
      formData.append('nom', nom);
      formData.append('email', email);
      formData.append('password', password);
      formData.append('poste', poste);
      if (image) {
        formData.append('image', image); 
      }

      const response = await axios.put('https://jetagroupe.com/api/admin/profile', formData, {
        headers: { 
          'Authorization': token,
          'Content-Type': 'multipart/form-data' 
        }
      });
      setMessage(response.data.msg);
    } catch (error) {
      if (error.response && error.response.data) {
        setMessage(error.response.data.msg);
      } else {
        setMessage('Erreur lors de la mise à jour du profil admin');
      }
    }
  };

  const togglePasswordVisibility = () => {
    setShowPassword(!showPassword);
  };

  return (
    <div className="admin-container">
      <AdminNavbar />
      <div className="admin-content">
        <AdminSidebar />
        <div className="modifier-profile-container">
          <h6>Modifier le Profil</h6>
          <form onSubmit={handleSubmit} className="modifier-profile-form">
            <div className="form-group">
              <label htmlFor="nom">Nom:</label>
              <input
                type="text"
                id="nom"
                value={nom}
                onChange={(e) => setNom(e.target.value)}
                required
              />
            </div>
            <div className="form-group">
              <label htmlFor="email">Email:</label>
              <input
                type="email"
                id="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                required
              />
            </div>
            <div className="form-group">
              <label htmlFor="password">Nouveau Mot de passe:</label>
              <div className="password-input-container3">
                <input
                  type={showPassword ? 'text' : 'password'}
                  id="password"
                  placeholder="Saisissez votre nouveau Mot de passe"
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                />
                <button
                  type="button"
                  onClick={togglePasswordVisibility}
                  className="toggle-password-visibility3"
                >
                  {showPassword ? <AiFillEye /> : <AiFillEyeInvisible />}
                </button>
              </div>
            </div>
            <div className="form-group">
              <label htmlFor="poste">Poste:</label>
              <input
                type="text"
                id="poste"
                value={poste}
                onChange={(e) => setPoste(e.target.value)}
                placeholder="Saisissez votre poste..."
              />
            </div>
            <div className="form-group">
              <label htmlFor="image">Nouvelle Image de Profil:</label>
              <input
                type="file"
                id="image"
                onChange={handleImageChange}
                accept="image/*"
              />
            </div>
            {message && <p className="message">{message}</p>}
            <button type="submit" className="submit-button-modif">Mettre à jour le Profil</button>
          </form>
        </div>
      </div>
    </div>
  );
}

export default ModifierProfile;
